// Выделение текущей страницы в TOC
(function () {
  var parts = location.pathname.split('/');
  var lastSegment = parts.pop() || parts.pop();  // handle potential trailing slash
  if (lastSegment === "") return;
  var menuItems = document.querySelectorAll('.toc a');
  for (var i = 0, len = menuItems.length; i < len; i++) {
    if (menuItems[i].getAttribute("href").indexOf(lastSegment) !== -1) {
      menuItems[i].closest('li').className += " current";
    }
  }
})();

// Translate

// Добавляем обработчик делегирования для переключения языка
document.querySelector('.lang-switcher').addEventListener('click', function(event) {
  const target = event.target;
  if (target.classList.contains('lang-switcher-item')) {
    const lang = target.id === 'switchToRu' ? 'ru' : 'uk';
    loadLocale(lang);
    setActiveLang(target);
  }
});

// Функция для установки активного языка
function setActiveLang(activeElement) {
  // Удаляем класс .active у всех элементов
  const items = document.querySelectorAll('.lang-switcher-item');
  items.forEach((item) => {
    item.classList.remove('active');
  });

  // Добавляем класс .active к выбранному элементу
  activeElement.classList.add('active');
}

// При загрузке страницы
document.addEventListener('DOMContentLoaded', function() {
  var locale = localStorage.getItem('locale') || 'uk';
  loadLocale(locale);
  
  // Установка активного класса на основе сохранённого языка
  const activeId = locale === 'ru' ? 'switchToRu' : 'switchToUk';
  setActiveLang(document.getElementById(activeId));
});

// Загрузка файла перевода
function loadLocale(locale) {
  localStorage.setItem('locale', locale);
  fetch('/assets/locales/' + locale + '.json')
      .then(response => response.json())
      .then(data => {
          applyTranslation(data); // Перевод основного содержимого
          applyDateTranslation(data); // Перевод дат
          applyIframeTranslation(data); // Перевод содержимого внутри iframe
      })
      .catch(error => console.error('Произошла ошибка при загрузке файла перевода:', error));
}

// ============================================
// Функция для перевода основного содержимого
// ============================================

// function applyTranslation(translations) {
//   document.querySelectorAll('[data-translate]').forEach(function(element) {
//     var key = element.getAttribute('data-translate');
//     key = key.replace(/^\/|\/$/g, '');
  
//     const minutes = element.getAttribute('data-minutes');
//     if (minutes) {
//       element.textContent = translations[key].replace('%', minutes);
//     } else {
//       element.textContent = translations[key];
//     }
//   });
// }

function applyTranslation(translations) {
  document.querySelectorAll('[data-translate]').forEach(function(element) {
    var key = element.getAttribute('data-translate');
    if (!key) {
      console.warn(`Атрибут 'data-translate' пуст или не установлен.`);
      return;
    }
    key = key.replace(/^\/|\/$/g, '');

    const counts = element.getAttribute('data-count');

    if (translations[key]) {
      if (counts) {
        let translatedString = translations[key];
        counts.split(',').forEach((count, index) => {
          const placeholder = `%${index + 1}`;
          translatedString = translatedString.replace(placeholder, count);
        });
        element.textContent = translatedString;
      } else {
        element.textContent = translations[key];
      }
    } else {
      console.warn(`Перевод для ключа "${key}" не найден.`);
    }
  });
  // Добавление логики для перевода <title>
  const titleElement = document.querySelector('title');
  if (titleElement) {
    const titleAuthor = titleElement.getAttribute('data-author');
    const titleTagName = titleElement.getAttribute('data-tag-name');
    const titleSite = titleElement.getAttribute('data-site-title');
    
    if (titleAuthor && titleTagName) {
      titleElement.textContent = translations[titleAuthor] + ' - ' + translations[titleTagName];
    } else if (titleSite) {
      titleElement.textContent = 'Boobaster. ' + translations["Personal website of the writer Evgeniy Is"];
    }
  }
}


// Примеры использования:
// 
// <span data-translate="issues" data-count="5"></span>
// {
//   "%1 issues": "%1 публикаций"
// }
// 
// <span data-translate="multipleVars" data-count="5,10"></span>
// {
//   "%1 out of %2 issues": "%1 из %2 публикаций"
// }

// ============================================
// Функция для перевода месяцев
// ============================================

function applyDateTranslation(translations) {
  document.querySelectorAll('time').forEach(function(element) {
    const datetime = element.getAttribute('datetime');
    if (datetime) {
      const [year, month, day] = datetime.split('-');
      const monthInt = parseInt(month, 10) - 1;
      const dayInt = parseInt(day, 10);
      const monthNames = [
        'January', 'February', 'March', 'April', 'May', 'June',
        'July', 'August', 'September', 'October', 'November', 'December'
      ];
      const monthName = monthNames[monthInt];
      const translatedMonth = translations[monthName];
      element.textContent = `${dayInt} ${translatedMonth} ${year}`;
    }
  });
}

// ============================================
// Функции для перевода содержимого внутри iframe
// ============================================

function applyIframeTranslation(translations) {
  handleCommentsFrame(translations);
  handlePortalTrigger(translations);
}

function handleCommentsFrame(translations) {
  var iframe = document.querySelector('iframe[title="comments-frame"]');
  if (!iframe) return;

  var iframeContent;

  var applyTranslationWhenLoaded = function() {
    iframeContent = iframe.contentDocument || iframe.contentWindow.document;
    var element = iframeContent.querySelector('h2.font-bold');

    if (element) {
      clearInterval(interval);

      var translationKeys = {
        'h2.font-bold': "Member discussion",
        'h1.font-semibold': "Start the conversation",
        '.ghost-display > div > div': 'comments',
        '.ghost-display > div > section > p': "Become a member to start commenting",
        '.ghost-display button.font-medium': "Sign up now",
        '.ghost-display > div > section > p > span': "Already a member?",
        '.ghost-display > div > section > p > button.font-semibold': "Sign in"
      };

      for (var selector in translationKeys) {
        var element = iframeContent.querySelector(selector);
        var key = translationKeys[selector];

        if (selector === '.ghost-display > div > div') {
          var fullText = element.textContent;
          var numberPart = fullText.match(/\d+/)[0];
          var translatedTextPart = translations[key];
          var translatedFullText = numberPart + ' ' + translatedTextPart;
          element.textContent = translatedFullText;
        } else {
          element.textContent = translations[key];
        }
      }
    }
  };

  var interval = setInterval(applyTranslationWhenLoaded, 100);
}

function handlePortalTrigger(translations) {
  var iframe = document.querySelector('iframe[title="portal-trigger"]');
  if (!iframe) return;

  var iframeContent;

  var applyTranslationWhenLoaded = function() {
    iframeContent = iframe.contentDocument || iframe.contentWindow.document;
    var element = iframeContent.querySelector('.gh-portal-triggerbtn-label');

    if (element) {
      clearInterval(interval);
      var key = "Subscribe";
      element.textContent = translations[key];
    }
  };

  var interval = setInterval(applyTranslationWhenLoaded, 100);
}

// Для iframe portal-popup используем MutationObserver, который будет наблюдать 
// за изменениями в DOM и запускать функцию перевода, когда появляется нужный iframe

function checkForIframePopup(translations) {
  var intervalId = setInterval(function() {
    var iframePopup = document.querySelector('iframe[title="portal-popup"]');
    if (iframePopup) {
      clearInterval(intervalId);
      console.log('iframe добавлен, применяем перевод');
      handlePortalPopup(iframePopup, translations);
    }
  }, 100);
}

// Пример события, которое может вызвать появление popup
document.addEventListener('DOMContentLoaded', function() {
  var closeBtn = document.querySelector('.gh-portal-close');
  
  if (closeBtn) {
    closeBtn.addEventListener('click', function() {
      checkForIframePopup(translations);
    });
  } else {
    console.warn('Кнопка с классом .gh-portal-close не найдена');
  }
});

function handlePortalPopup(iframe, translations) {
  var iframeContent;
  
  var applyTranslationWhenLoaded = function() {
    iframeContent = iframe.contentDocument || iframe.contentWindow.document;
    var element = iframeContent.querySelector('h1.gh-portal-main-title');

    if (element) {
      clearInterval(interval);
      var key = "Sign in";
      element.textContent = translations[key];
    }
  };

  var interval = setInterval(applyTranslationWhenLoaded, 100);
}

// При загрузке документа начинаем наблюдение за добавлением iframe
// document.addEventListener('DOMContentLoaded', function() {
//   var locale = localStorage.getItem('locale') || 'uk';
//   fetch('/assets/locales/' + locale + '.json')
//     .then(response => response.json())
//     .then(data => {
//       observeIframePopup(data);
//       // ... остальные действия
//     });
// });


// Проверка необходимости подгрузки постов
(function () {
  if (document.querySelector('.gh-loadmore')) {
    if ('isInfinite' in window) {
      pagination(isInfinite);
    } else {
      pagination(false);
    }
  }
})();
